import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { GLOBAL } from '../shared/global';
import { tokenNotExpired } from 'angular2-jwt/angular2-jwt';
import { RolePermission } from '../shared/role-permission/role-permission';
import { User, UserFactory } from '../shared/model/user.entity';
import { ROLE } from '../shared/model/role.enum';
import { SCREEN_LOCK_TIMEOUT } from '../shared/constants';

// we use screen-guard-test for e2e testing purpose so that we don't have to wait for whole 30min
export const ScreenLockTimeout = hasSearchParams('screen-guard-test') ? 5000 : SCREEN_LOCK_TIMEOUT; // 30 mins
export const LOGIN_AT = 'loginAt';
@Injectable()
export class AuthGuard implements CanActivate {

    public static isLoggedIn(): boolean {
        let u = localStorage.getItem('user');
        if (u === 'undefined' || u === null) {
            // this.logout();
            return false;
        } else {
            let data = JSON.parse(u);
            GLOBAL.currentUser = Boolean(!GLOBAL.currentUser) ? UserFactory.createUser(data) : GLOBAL.currentUser;
        }
        let user = GLOBAL.currentUser;
        let res = user && user.email && user.id && user.type;
        return !!res;
    }

    public static logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('userId');
        localStorage.removeItem('message');

        GLOBAL.currentUser = undefined;
        GLOBAL.currentInterpreter = undefined;
    }

    public static login(user) {
      GLOBAL.currentUser = user;
      AuthGuard.setToken(user.token);
      localStorage.setItem('user', JSON.stringify(GLOBAL.currentUser));
    }

    public static   refreshUser(user) {
      AuthGuard.setUser(user);
      localStorage.setItem('user', JSON.stringify(GLOBAL.currentUser));
    }

    static setUser(user) {
      GLOBAL.currentUser = user;
      user.password = '************';
    }

    static getUser() {
      const user = localStorage.getItem('user');
      if (user === null) {
        return null;
      }

      return JSON.parse(user) as User;
    }

    static getSessionLeftTime() {
      const loginAt = localStorage.getItem(LOGIN_AT);
      const screenLockTimePastInMs = new Date().valueOf() - ScreenLockTimeout;
      return Math.max(0, new Date(+loginAt).valueOf() - screenLockTimePastInMs);
    }

    static isSessionExpired() {
      const isSessionTimeEnd = AuthGuard.getSessionLeftTime() === 0;
      const tokenInvalid = AuthGuard.isTokenInvalid();
      return isSessionTimeEnd || tokenInvalid;
    }

    static isTokenInvalid() {
      const token = localStorage.getItem('token');
      return !(token && tokenNotExpired('token', token));
    }

    static setToken(token: string) {
      localStorage.setItem('token', token);
      AuthGuard.updateSessionTime();
    }

    static updateSessionTime(key = LOGIN_AT) {
      localStorage.setItem(key, JSON.stringify(+new Date()));
    }

    static removeToken() {
      localStorage.removeItem('token');
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (AuthGuard.isLoggedIn()) {
            if ( null === GLOBAL.currentUser || GLOBAL.currentUser === undefined ) {
                // logged in but opened a new tab
                 this.router.navigate(['/dashboard']);
            } else if ( GLOBAL.currentUser instanceof User) {
                let res = this.rolePermission.isRestrictedRouteForCurrentUser(state.url);
                return !res;
            }
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/authenticate'], { queryParams: { returnUrl: state.url } });
        return false;
    }

    constructor(public router: Router, private rolePermission: RolePermission) {

    }
}

export function hasSearchParams(key: string) {
  const {href} = location;
  const queryIdentifierIndex = href.indexOf('?');
  if (queryIdentifierIndex === -1) {
    return false;
  }

  const urlSearchParams = new URLSearchParams(href.slice(queryIdentifierIndex + 1));

  return urlSearchParams.has(key);
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.guard.ts